"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
var _ = require("lodash");
var react_toastify_1 = require("react-toastify");
var constants_1 = require("../../../constants");
var server_1 = require("../../../helpers/server");
var Actions = /** @class */ (function () {
    function Actions() {
    }
    Actions.getWeeklyWorkDays = function (date, page, pageSize, filtered, sorted, userIds, userStatus, weekDayStatus, approveStatus, controlStatus, userRole) {
        var _this = this;
        this.paramsCache = [date, page, pageSize, filtered, sorted, userIds, userStatus, weekDayStatus, controlStatus, approveStatus, userRole];
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.WEEK_DAYS).request, payload: { page: page, pageSize: pageSize } });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.WORK_DAY_URI + '/week', {
                                page: page,
                                pageSize: pageSize,
                                sortOrder: _.get(sorted, '[0].desc', false),
                                filterText: _.get(filtered, '[0].value', ''),
                                date: date,
                                userIds: userIds,
                                userStatus: userStatus,
                                userRole: userRole,
                                weekDayStatus: weekDayStatus,
                                approveStatus: approveStatus,
                                controlStatus: controlStatus,
                            }, true)];
                    case 2:
                        result = _a.sent();
                        if (result.success) {
                            dispatch({ type: (0, server_1.apiActions)(this.WEEK_DAYS).success, payload: result });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.WEEK_DAYS).fail, payload: error_1 });
                        react_toastify_1.toast.error(error_1.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.getActivities = function (user, date) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.ACTIVITIES).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.WORK_DAY_URI, {
                                user: user,
                                date: date,
                            }, true)];
                    case 2:
                        result = _a.sent();
                        if (result.result) {
                            dispatch({ type: (0, server_1.apiActions)(this.ACTIVITIES).success, payload: _.get(result, 'data.activities', []) });
                        }
                        else {
                            dispatch({ type: (0, server_1.apiActions)(this.ACTIVITIES).fail });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.ACTIVITIES).fail, payload: error_2 });
                        react_toastify_1.toast.error(error_2.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.recalculateWorkDay = function (user, date) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.RECALCULATE_WORKDAY).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)("".concat(constants_1.API.WORK_DAY_URI, "/recalculate"), { user: user, date: date }, true)];
                    case 2:
                        result = _a.sent();
                        if (result.result) {
                            dispatch({
                                type: (0, server_1.apiActions)(this.RECALCULATE_WORKDAY).success,
                                payload: {
                                    activities: result.data.workday.activities,
                                    weekDays: result.data.weekDays
                                }
                            });
                        }
                        else {
                            dispatch({ type: (0, server_1.apiActions)(this.RECALCULATE_WORKDAY).fail });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.RECALCULATE_WORKDAY).fail, payload: error_3 });
                        react_toastify_1.toast.error(error_3.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.controlWeekDays = function (date, userIds, requestDate, ignoreClosedOrders) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, controlCounter, message, _i, _a, controlledWeek, error_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.CONTROL_WEEK).request });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.WORK_DAY_URI + '/control', {
                                date: date,
                                userIds: userIds,
                                ignoreClosedOrders: ignoreClosedOrders,
                                lastDate: requestDate
                            })];
                    case 2:
                        result = _b.sent();
                        if (result.success) {
                            dispatch({ type: (0, server_1.apiActions)(this.CONTROL_WEEK).success, payload: result.data });
                            controlCounter = _.countBy(result.data, 'controlled');
                            if (controlCounter.hasOwnProperty('true')) {
                                message = controlCounter.true === 1 ? 'gebruiker is ' : controlCounter.true + ' gebruikers zijn ';
                                react_toastify_1.toast.success(message + 'gecontroleerd');
                            }
                            for (_i = 0, _a = result.data; _i < _a.length; _i++) {
                                controlledWeek = _a[_i];
                                if (controlledWeek.hasClosedOrders) {
                                    dispatch({
                                        type: (0, server_1.apiActions)(this.CONTROL_WEEK).message,
                                        payload: controlledWeek.message
                                    });
                                    react_toastify_1.toast.error('Voor ' + controlledWeek.fullName + ' has closed orders');
                                    break;
                                }
                                if (!controlledWeek.controlled) {
                                    react_toastify_1.toast.error('Voor ' + controlledWeek.fullName + ' ' + controlledWeek.message, { autoClose: false });
                                }
                            }
                        }
                        else {
                            react_toastify_1.toast.warn('De waarden zijn veranderd. Controleer en probeer het opnieuw');
                            this.getWeeklyWorkDays.apply(this, this.paramsCache)(dispatch);
                            dispatch({ type: (0, server_1.apiActions)(this.CONTROL_WEEK).fail });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _b.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.CONTROL_WEEK).fail, payload: error_4 });
                        react_toastify_1.toast.error(error_4.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.approveWeekDays = function (date, userIds, requestDate, ignoreClosedOrders) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, approveCounter, message, _i, _a, approvedWeek, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.APPROVE_WEEK).request });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.WORK_DAY_URI + '/approve', {
                                date: date,
                                userIds: userIds,
                                ignoreClosedOrders: ignoreClosedOrders,
                                lastDate: requestDate
                            })];
                    case 2:
                        result = _b.sent();
                        if (result.success) {
                            dispatch({ type: (0, server_1.apiActions)(this.APPROVE_WEEK).success, payload: result.data });
                            approveCounter = _.countBy(result.data, 'approved');
                            if (approveCounter.hasOwnProperty('true')) {
                                message = approveCounter.true === 1 ? 'gebruiker is ' : approveCounter.true + ' gebruikers zijn ';
                                this.getWeeklyWorkDays.apply(this, this.paramsCache)(dispatch);
                                react_toastify_1.toast.success(message + 'goedgekeurd');
                            }
                            for (_i = 0, _a = result.data; _i < _a.length; _i++) {
                                approvedWeek = _a[_i];
                                if (approvedWeek.hasClosedOrders) {
                                    dispatch({
                                        type: (0, server_1.apiActions)(this.APPROVE_WEEK).message,
                                        payload: approvedWeek.message
                                    });
                                    react_toastify_1.toast.error('Voor ' + approvedWeek.fullName + ' has closed orders');
                                    break;
                                }
                                if (!approvedWeek.approved || approvedWeek.has_error) {
                                    react_toastify_1.toast.error('Voor ' + approvedWeek.fullName + ' ' + approvedWeek.message, { autoClose: false });
                                }
                            }
                        }
                        else {
                            react_toastify_1.toast.warn('De waarden zijn veranderd. Controleer en probeer het opnieuw');
                            this.getWeeklyWorkDays.apply(this, this.paramsCache)(dispatch);
                            dispatch({ type: (0, server_1.apiActions)(this.APPROVE_WEEK).fail });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _b.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.APPROVE_WEEK).fail, payload: error_5 });
                        react_toastify_1.toast.error(error_5.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.unapproveWeekDays = function (date, userIds, requestDate) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.UNDO_APPROVE_WEEK).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.deleteRequest)(constants_1.API.WORK_DAY_URI + '/approve', {
                                date: date,
                                userIds: userIds,
                                lastDate: requestDate
                            }, {})];
                    case 2:
                        result = _a.sent();
                        if (result.success) {
                            dispatch({ type: (0, server_1.apiActions)(this.UNDO_APPROVE_WEEK).success, payload: result.data });
                            this.getWeeklyWorkDays.apply(this, this.paramsCache)(dispatch);
                            react_toastify_1.toast.success('Goedkeuringen ongedaan gemaakt');
                        }
                        else {
                            react_toastify_1.toast.error('Er is een fout opgetreden bij het ongedaan maken van de goedkeuringen: ' + result.message || '');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.UNDO_APPROVE_WEEK).fail, payload: error_6 });
                        react_toastify_1.toast.error(error_6.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.createWorkLog = function (worklog) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_7, userIds, pageSize;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_CREATE).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, 8, 9]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.WORKLOG_URI + '/create', __assign({}, worklog))];
                    case 2:
                        result = _a.sent();
                        if (!result.result) return [3 /*break*/, 4];
                        return [4 /*yield*/, dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_CREATE).success, payload: result })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_CREATE).fail, payload: result })];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        error_7 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_CREATE).fail, payload: error_7 });
                        react_toastify_1.toast.error(error_7.message);
                        return [3 /*break*/, 9];
                    case 8:
                        userIds = getState().reducer.WeekDaysReducer.selectedUsers;
                        pageSize = getState().reducer.WeekDaysReducer.pageSize;
                        Actions.getWeeklyWorkDays(worklog.date_worked || '', 0, pageSize, null, null, userIds)(dispatch);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.updateWorkLog = function (worklog) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_UPDATE).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.put)(constants_1.API.WORKLOG_URI + '/update', '', __assign({}, worklog))];
                    case 2:
                        result = _a.sent();
                        if (result.result) {
                            dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_UPDATE).success, payload: result });
                        }
                        else {
                            dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_UPDATE).fail, payload: result });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_UPDATE).fail, payload: error_8 });
                        react_toastify_1.toast.error(error_8.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.deleteWorkLog = function (worklog) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_9, userIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_DELETE).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, server_1.deleteRequest)(constants_1.API.WORKLOG_URI + '/delete', {
                                _id: worklog._id,
                                date: worklog.date_worked,
                                owner: worklog.owner,
                            }, {})];
                    case 2:
                        result = _a.sent();
                        if (result.result) {
                            dispatch({
                                type: (0, server_1.apiActions)(this.WORKLOG_DELETE).success,
                                payload: __assign(__assign({}, result), { worklog: worklog }),
                            });
                        }
                        else {
                            dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_DELETE).fail, payload: result });
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_9 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(this.WORKLOG_DELETE).fail, payload: error_9 });
                        react_toastify_1.toast.error(error_9.message);
                        return [3 /*break*/, 5];
                    case 4:
                        userIds = getState().reducer.WeekDaysReducer.selectedUsers;
                        Actions.getWeeklyWorkDays(worklog.date_worked || '', 0, userIds.length, null, null, userIds)(dispatch);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    };
    Actions.setSelectedUsers = function (userIds) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch({ type: this.SET_SELECTED_USERS, payload: userIds });
                return [2 /*return*/];
            });
        }); };
    };
    Actions.onWorkLogUpdated = function (worklog) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch({ type: this.ON_WORKLOG_UPDATED, payload: worklog });
                return [2 /*return*/];
            });
        }); };
    };
    Actions.ACTIVITIES = 'ACTIVITIES';
    Actions.RECALCULATE_WORKDAY = 'RECALCULATE_WORKDAY';
    Actions.WEEK_DAYS = 'WEEK_DAYS';
    Actions.APPROVE_WEEK = 'APPROVE_WEEK';
    Actions.UNDO_APPROVE_WEEK = 'UNDO_APPROVE_WEEK';
    Actions.CONTROL_WEEK = 'CONTROL_WEEK';
    Actions.SET_SELECTED_USERS = 'SET_SELECTED_USERS';
    Actions.ON_WORKLOG_UPDATED = 'ON_WORKLOG_UPDATED';
    Actions.WORKLOG_UPDATE = 'WORKLOG_UPDATE';
    Actions.WORKLOG_CREATE = 'WORKLOG_CREATE';
    Actions.WORKLOG_DELETE = 'WORKLOG_DELETE';
    Actions.paramsCache = [];
    return Actions;
}());
exports.Actions = Actions;
